import * as React from "react";

// eslint-disable-next-line no-restricted-imports
import { renderAppFlyoutAnchor } from "@1js/acui-button/lib/Next";

import type { RibbonFlyoutAnchorInternalProps } from "../RibbonFlyoutAnchor";
import { useRibbonFlyoutAnchor } from "./useRibbonFlyoutAnchor";
import { shallowCompareWithMenuDefinitionCheck } from "@1js/acui-common";
import type { RibbonFlyoutAnchorProps } from "./RibbonFlyoutAnchor.types";
import { useRibbonFlyoutAnchorStyles } from "./useRibbonFlyoutAnchorStyles.styles";

export const RibbonFlyoutAnchor = React.memo(
  React.forwardRef<HTMLButtonElement, RibbonFlyoutAnchorInternalProps>(
    (props, ref) => {
      const state = useRibbonFlyoutAnchor(
        {
          ...props,
          size: props.size?.toLowerCase() as RibbonFlyoutAnchorProps["size"],
        },
        ref
      );
      // eslint-disable-next-line react-hooks/rules-of-hooks
      useRibbonFlyoutAnchorStyles(state, props);
      return renderAppFlyoutAnchor(state, props);
    }
  ),
  shallowCompareWithMenuDefinitionCheck
);

RibbonFlyoutAnchor.displayName = "next/RibbonFlyoutAnchor";
